// extracted by css-extract-rspack-plugin
export default {"back-button":"back-button-eydtYa","backButton":"back-button-eydtYa"};